import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BannerGroupBannerList, ShopUxBannerLinkType } from '@domains/storehome-common';

interface Props {
  banner_item: BannerGroupBannerList;
  onClick?: ({
    link,
    link_type,
    id,
  }: {
    link: string | undefined;
    link_type: ShopUxBannerLinkType | null;
    id: string;
  }) => void;
}

export const SelectedBannerItem = ({ banner_item, onClick }: Props) => {
  const { id, image_url, title, sub_title, link_type, link_button } = banner_item;

  if (!image_url) {
    return null;
  }

  const titles = title?.split('\n');

  return (
    <RatioWrap>
      <Item onClick={() => onClick?.({ link: link_button?.link_url, link_type, id })}>
        <ImageWrapper>
          <img className='bg_blured' src={image_url} alt={`blured_${title ?? ''}`} />
          <img className='image' src={image_url} alt={title ?? ''} />
        </ImageWrapper>
        <Dim is_upper />
        <Titles id='storehome-banner-title'>
          {titles && (
            <h2 className='title'>
              {titles[0]}
              {titles[1] ? (
                <>
                  <br />
                  {titles[1]}
                </>
              ) : null}
            </h2>
          )}
          {sub_title && (
            <Text as='p' variant='Body_15_Regular' color='staticWhite' className='sub-title'>
              {sub_title}
            </Text>
          )}
        </Titles>
        <Dim />
      </Item>
    </RatioWrap>
  );
};

const RatioWrap = styled.div`
  position: relative;
  padding: 0 0 170% 0;
  overflow: hidden;
  width: 100%;
  height: 0;
`;

const Item = styled.div`
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 720px;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  .bg_blured {
    position: absolute;
    z-index: 1;
    width: 110%;
    top: 50%;
    transform: translateY(-45%);
    height: auto;
    object-fit: cover;
    object-position: 50% 50%;
    filter: blur(10px);
  }
  .image {
    position: relative;
    z-index: 10;
    width: auto;
    height: 100%;
    max-height: 720px;
    object-fit: cover;
    object-position: 50% 50%;
  }
`;

const Dim = styled.div<{ is_upper?: boolean }>`
  position: absolute;
  width: 100%;
  left: 0;
  z-index: 15;
  ${({ is_upper }) =>
    is_upper
      ? css`
          top: 0;
          height: 160px;
          opacity: 0.2;
          background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0, rgba(0, 0, 0, 0) 100%);
        `
      : css`
          bottom: 0;
          height: 300px;
          opacity: 0.3;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 100%);
        `};
  pointer-events: none;
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  padding: 0 32px;
  box-sizing: border-box;
  width: 100%;
  bottom: 102px;
  color: ${vars.color.staticWhite};
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
  align-items: center;

  transition:
    transform 0.5s 0.1s ease-in-out,
    opacity 0.4s 0.1s linear;
  overflow: hidden;
  word-break: keep-all;
  text-align: center;
  z-index: 20;

  transform: translateX(-45%);

  .single-banner &,
  .swiper-slide-active & {
    opacity: 1;
    transform: translateX(-50%);
  }

  @media screen and (min-width: 418px) {
    bottom: 115px;
    text-align: left;
    padding: 0 60px;
    align-items: flex-start;
  }

  .title {
    padding-top: 16px;
    font-size: 32px;
    font-weight: 500;
    max-width: 310px;
  }
  .sub-title {
    padding-top: 16px;
    max-width: 310px;
  }
`;
